/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RenditionsControllerFindOneQueryResponse, RenditionsControllerFindOnePathParams, RenditionsControllerFindOneQueryParams, RenditionsControllerFindOne400, RenditionsControllerFindOne401, RenditionsControllerFindOne403, RenditionsControllerFindOne404 } from "../../models/documentRenditionsController/RenditionsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { renditionsControllerFindOne } from "../../clients/document-renditionsService/renditionsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const renditionsControllerFindOneQueryKey = (documentId: RenditionsControllerFindOnePathParams["documentId"], renditionId: RenditionsControllerFindOnePathParams["renditionId"], params: RenditionsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId',
  params: {
    documentId: documentId,
    renditionId: renditionId
  }
}, ...(params ? [params] : [])] as const;
export type RenditionsControllerFindOneQueryKey = ReturnType<typeof renditionsControllerFindOneQueryKey>;
export function renditionsControllerFindOneQueryOptions(documentId: RenditionsControllerFindOnePathParams["documentId"], renditionId: RenditionsControllerFindOnePathParams["renditionId"], params?: RenditionsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = renditionsControllerFindOneQueryKey(documentId, renditionId, params);
  return queryOptions<RenditionsControllerFindOneQueryResponse, ResponseErrorConfig<RenditionsControllerFindOne400 | RenditionsControllerFindOne401 | RenditionsControllerFindOne403 | RenditionsControllerFindOne404>, RenditionsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return renditionsControllerFindOne(documentId, renditionId, params, config);
    }
  });
}

/**
 * @description Returns a specific rendition by its ID
 * @summary Get a specific rendition
 * {@link /api/v1/documents/:documentId/renditions/:renditionId}
 */
export function useRenditionsControllerFindOne<TData = RenditionsControllerFindOneQueryResponse, TQueryData = RenditionsControllerFindOneQueryResponse, TQueryKey extends QueryKey = RenditionsControllerFindOneQueryKey>(documentId: RenditionsControllerFindOnePathParams["documentId"], renditionId: RenditionsControllerFindOnePathParams["renditionId"], params?: RenditionsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<RenditionsControllerFindOneQueryResponse, ResponseErrorConfig<RenditionsControllerFindOne400 | RenditionsControllerFindOne401 | RenditionsControllerFindOne403 | RenditionsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? renditionsControllerFindOneQueryKey(documentId, renditionId, params);
  const query = useQuery({
    ...renditionsControllerFindOneQueryOptions(documentId, renditionId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<RenditionsControllerFindOne400 | RenditionsControllerFindOne401 | RenditionsControllerFindOne403 | RenditionsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}